<div class="flex breadcrumbs-container mapfre-hide-mobile mapfre-hide-tablet">
    <div *ngFor="let ele of breadcrumbs;let last = last" class="flex breadcrumbs-element" [ngClass]="{'cp':ele.navTo}"
    (click)="navTo(ele)"
    >
        <div class="mapfre-fs-xs dark-blue text" [ngClass]="{ last }">
            <span *ngIf="ele.noCapitalize">{{ele.label | translate }}</span>
            <span *ngIf="!ele.noCapitalize">{{ele.label | translate  | titlecase}}</span>
        </div>
        <img [ngClass]="{ last }" class="mapfre-ml-sm mapfre-mr-sm" src="assets/icons/arrow-right.svg" alt="">
    </div>
</div>